import { useEffect, useLayoutEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const KEY = "scroll_positions";
const read = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || "{}"); } catch { return {}; } };
const positions = read();
// La prima voce di un documento appena caricato ha sempre key "default": la posizione salvata appartiene a un altro caricamento
delete positions.default;
const persist = () => {
  const keys = Object.keys(positions);
  if (keys.length > 100) delete positions[keys[0]];
  try { sessionStorage.setItem(KEY, JSON.stringify(positions)); } catch { /* quota */ }
};

// Ripristina la posizione di scorrimento quando si torna indietro (pulsante "Indietro" del CRM o del browser).
// Le liste caricano i dati in modo asincrono: si riprova finché la pagina è abbastanza alta (max ~4s).
export default function ScrollRestorer() {
  const location = useLocation();
  const navType = useNavigationType();
  const keyRef = useRef(location.key);

  useEffect(() => {
    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
  }, []);

  useEffect(() => {
    const key = location.key;
    let t = null;
    const onScroll = () => {
      if (keyRef.current !== key) return;
      positions[key] = window.scrollY;
      clearTimeout(t);
      t = setTimeout(persist, 150);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => { clearTimeout(t); persist(); window.removeEventListener("scroll", onScroll); };
  }, [location.key]);

  useLayoutEffect(() => {
    keyRef.current = location.key;
    if (navType !== "POP") { window.scrollTo(0, 0); return; }
    const y = positions[location.key];
    if (!y) return;
    let tries = 0;
    let cancelled = false;
    const stop = () => { cancelled = true; };
    window.addEventListener("wheel", stop, { passive: true });
    window.addEventListener("touchmove", stop, { passive: true });
    const attempt = () => {
      if (cancelled || keyRef.current !== location.key) return;
      const maxY = document.documentElement.scrollHeight - window.innerHeight;
      window.scrollTo(0, Math.min(y, Math.max(maxY, 0)));
      if (maxY >= y || tries++ > 40) return;
      setTimeout(attempt, 100);
    };
    attempt();
    return () => {
      cancelled = true;
      window.removeEventListener("wheel", stop);
      window.removeEventListener("touchmove", stop);
    };
  }, [location.key, navType]);

  return null;
}
